export const STATUS = {
  NEW: 'new',
  STARTED: 'started',
  FINISHED: 'finished',
} as const;

export type Status = typeof STATUS[keyof typeof STATUS];
export type PersistedStatus = Exclude<Status, typeof STATUS.NEW>;